import React from 'react'
import Chip from '@mui/material/Chip'
import StarRateIcon from '@mui/icons-material/StarRate'

interface ComponentProps {
  vipFlag: boolean
}

export const MemberVIPChip: React.FC<ComponentProps> = ({ vipFlag }: ComponentProps): JSX.Element => {
  return (vipFlag
    ? (
          <Chip icon={<StarRateIcon />} label="VIP" color={'secondary'} />
      )
    : (
          <></>
      )
  )
}
